import react, { useEffect, useLayoutEffect, useReducer, useState } from 'react'
import { lockedReducer } from '../../../utils/defaultReducer'
import { Box, List, Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import api from '../../../api'
import HistoricRow from './historic_row'
import { getSession } from '../../../auth'
import dayjs from 'dayjs'
import EditList from '../../Scout/Pages/EditList'
import { useHistory } from "react-router-dom"
import { useLocation } from "react-router-dom"
import { actions } from './historic_row'

export const moveToOpportunity = (journey, opportunity, history, location) => {
    const urlParams = new URLSearchParams()
    urlParams.set("selectedTab", "journeys")
    urlParams.set("selectedJourney", journey)
    urlParams.set("selectedCard", opportunity)
    history.push(`${location.pathname}?${urlParams.toString()}`)
}

const LoadMore = async (contact, rows, cursor, setParent, supervisedQueues = [], category = 'ALL') => {
    setParent({ loading: true })
    const res = await api.get(`/api/enterprises/${contact.enterprise}/contacts/cursor/${contact.id}/${cursor}/?queues=${supervisedQueues.join(",")}&category=${category}`)
    const newstate = { loading: false }
    if (res.status === 200) {
        const [newrows, newcursor] = res.data
        newstate.historic = [[...rows, ...newrows], newcursor]
    }
    setParent(newstate)
}

const getScout = async (contact, setState) => {

    const res = await api.post(
        `api/enterprises/${contact.enterprise}/scout_accounts/customer_contacts/`,
        {
            phone_number: contact.telephone,
        },
    );
    if (res.status === 200) {
        setState({
            scoutRows: res.data.map(row => {
                const date = dayjs.unix(row.last_message_timestamp)
                return (
                    {
                        ...row, accounts: [row.account],
                        activeAccount: { ...row.account, enterprise: contact.enterprise },
                        activeChat: { id: row.id },
                        messages: row.messages.toSorted((x, y) => x.timestamp - y.timestamp),
                        platform_entrypoint: 'SCOUT',
                        data: date.format('DD/MM/YYYY'),
                        time: date.format('HH:mm:ss'),
                        timestamp: row.last_message_timestamp, setState: setState,
                        uniqueid: `SCOUT_${row.id}_${row.last_message_timestamp}`,
                    }
                )
            })
        })
    }
    return [[], 0]
}



const HistoricComponent = ({ contact, data, setParent, supervisedQueues = [], category='ALL'}) => {

    const history = useHistory()
    const location = useLocation()

    const [state, setState] = useReducer(lockedReducer, {
        activeDialog: null,
        scoutRows: [],
        editList: null,
    })

    const [rows, cursor] = data

    useLayoutEffect(() => {
        const enterprise = getSession()?.profile?.enterprise
        if (enterprise?.platforms?.scout)
            getScout(contact, setState)
    }, [])

    const mergedRows = [
        ...rows.map(row => {
            const return_row = row
            if (return_row.platform_entrypoint === 'OPPORTUNITY_COMMENT')
                return ({
                    ...return_row, viewopportunity: () => {
                        moveToOpportunity(return_row.journey_id, return_row.id, history, location)
                    }
                })
            return return_row
        }
        ), ...(['ALL', 'SCOUT'].includes(category) ? state.scoutRows : [])
    ].toSorted((a, b) => b.timestamp - a.timestamp).filter((row => {
        const seen = new Set()
        return r => {
            if (seen.has(r.uniqueid)) return false
            seen.add(r.uniqueid)
            return true
        }
    })()) // Filtering rows with the same uniqueid (transferences)

    return (
        <Box>
            <FormControl size='small' sx={{ margin: '.5rem 0rem', minWidth: '13rem' }}>
                <InputLabel id='filter-category-select-item'>Canal</InputLabel>
                <Select
                    labelId='filter-category-select-item'
                    label='Canal'
                    value={category}
                    onChange={({ target }) => LoadMore(contact, [], 0, setParent, supervisedQueues, target.value).
                    then(() => setParent({category : target.value}))}
                >
                    <MenuItem value='ALL'>Todos*</MenuItem>
                    {Object.entries(actions).flatMap(([key, value]) => {
                    const data = value({data: {opportunity_name: ''}})
                    if (!data.filter) return []
                    return (
                        <MenuItem value={key}>{data.name}</MenuItem>
                    )})}
                </Select>
            </FormControl>
            {state.editList && <EditList data={state.editList} handleClose={() => setState({ editList: null })} />}
            {state.activeDialog}
            <List className='historic-list-gap'>
                {mergedRows.map(row => (
                    <HistoricRow key={`historic-unique-row-${row.id}`} data={row} contact={contact} setParent={setState} />
                ))}
            </List>
            {(data[0].length > 0 && cursor !== -1) &&
                <Box className='historic-show-more'>
                    <Button onClick={() => LoadMore(contact, rows, cursor, setParent, supervisedQueues, category)}>Mostrar mais</Button>
                </Box>
            }
        </Box>
    )
}

export default HistoricComponent